import { render } from "./ModalPapara.vue?vue&type=template&id=11b82ea6&scoped=true"
import script from "./ModalPapara.vue?vue&type=script&lang=js"
export * from "./ModalPapara.vue?vue&type=script&lang=js"

import "./ModalPapara.vue?vue&type=style&index=0&id=11b82ea6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b82ea6"]])

export default __exports__